// extracted by mini-css-extract-plugin
export default {"news-wrapper":"news-wrapper--TT7Nj","newsWrapper":"news-wrapper--TT7Nj","news":"news--JQpTk","news-tem":"news-tem--DJljw","newsTem":"news-tem--DJljw","blink":"blink--oJXCZ"};